import { useTranslation } from "react-i18next";
import * as Yup from "yup";

// const MIN_PASSWORD_LENGTH = 8;

export function useLoginlinkSchema() {
  const { t } = useTranslation();

  return Yup.object().shape({
    password: Yup.string()
      // .min(
      //   MIN_PASSWORD_LENGTH,
      //   t("label.minCharacterLengthValidation", {
      //     field: t("label.password"),
      //     value: MIN_PASSWORD_LENGTH,
      //   })
      // )
      .required(t("label.isRequiredValidation", { field: t("label.password") })),
    passwordConfirmation: Yup.string()
      .required(
        t("label.isRequiredValidation", {
          field: t("label.password"),
        })
      )
      .oneOf([Yup.ref("password"), " s"], t("label.passwordsMustMatch")),
  });
}
